import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { UserPermissionsService } from '@app/core/user-permissions/user-permissions.service';
import { DirectSubscriptionService } from '@app/modules/direct/services/direct-subscription.service';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, take, tap } from 'rxjs/operators';
import { NotificationType } from '../interfaces';
import { ToastNotificationsService } from '../services/toast-notifications/toast-notifications.service';

@Injectable({
  providedIn: 'root',
})
export class AccessToBillingGuard  {
  constructor(
    private permissions: UserPermissionsService,
    private router: Router,
    private toast: ToastNotificationsService,
    private directSubscription: DirectSubscriptionService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Check to make sure that the user is the primary user, and also has been onboarded to Direct
    return combineLatest([
      this.permissions.loaded.pipe(filter((loaded) => loaded !== null)),
      this.directSubscription.subscriptionStatus$.pipe(filter((status) => status !== null)),
      this.permissions.isPrimaryUser().pipe(filter((isPrimary) => isPrimary !== null)), // Add isPrimaryUser to the combineLatest
    ]).pipe(
      take(1),
      map(([permissionsLoaded, subscriptionStatus, isPrimaryUser]) => {
        if (!permissionsLoaded || !isPrimaryUser || !subscriptionStatus.onboarded) {
          this.toast.open('You do not have access to this page', 'Dismiss', NotificationType.Error);
          return this.router.parseUrl('/');
        }
        return true;
      })
    );
  }
}
